import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function Refresh(props) {
    return (React.createElement(Svg, { width: props?.size ? props.size : 14, height: props?.size ? props.size : 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(G, { clipPath: "url(#clip0_1365_839)", stroke: props.color ? props.color : "#1434CB", strokeWidth: 0.875, strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement(Path, { d: "M10.063 5.688h2.624V3.063" }),
            React.createElement(Path, { d: "M10.303 10.5a4.812 4.812 0 11.1-6.903l2.284 2.09" })),
        React.createElement(Defs, null,
            React.createElement(ClipPath, { id: "clip0_1365_839" },
                React.createElement(Path, { fill: "#fff", d: "M0 0H14V14H0z" })))));
}
export default Refresh;
